import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import DermaRangeSlider from "../Components/DermaRangeSlider";
import "./Theme.css";
import "./IntensityOfSymptoms.css";

const IntensityOfSymptoms = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const uuid = urlParams.get("uuid") || "";
  const goqiiUserId = getGoqiiUserId();
  const nonce = urlParams.get("nonce") || "";
  const apiKey = urlParams.get("apiKey") || "";
  const signature = urlParams.get("signature") || "";
  const goqiiAccessToken = urlParams.get("goqiiAccessToken") || "";

  const [itchIntensity, setItchIntensity] = useState(0);
  const [sleeplessness, setSleeplessness] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await lifestyleApi.logIntensitySymptoms({ itchIntensity, sleeplessness });
      const qs = `uuid=${uuid}&goqiiuserid=${goqiiUserId}&nonce=${nonce}&apiKey=${apiKey}&signature=${signature}&goqiiAccessToken=${goqiiAccessToken}&theme=${theme}&lang=${lang}`;
      navigate(`/scorad-details?${qs}`);
    } catch (err) {
      // logIntensitySymptoms error
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="ios-sym-page">
        <div className="ios-sym-container">
          <div className="ios-sym-block">
            <label className="ios-sym-label">{t("intensitySymptoms.itchLabel")}</label>
            <DermaRangeSlider handleValue={setItchIntensity} />
          </div>
          <div className="ios-sym-block">
            <label className="ios-sym-label">{t("intensitySymptoms.sleepLabel")}</label>
            <DermaRangeSlider handleValue={setSleeplessness} />
          </div>
        </div>
      </section>
      <section className="ios-sym-bottom">
        <button className="ios-sym-btn" disabled={loading} onClick={handleSubmit}>
          {loading ? t("common.loading") : t("common.done")}
        </button>
      </section>
    </>
  );
};

export default IntensityOfSymptoms;
